import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import moment from 'moment'
//SERVICES
import { getPagamentos } from '../../services/PagamentoService';

export default function Pagamentos() {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    getPagamentos().then(async (res) => {
      setData(res?.data?.rows)
    })
      .catch(err => { })
  }, [])

  const customStyles = {
    pending: {
      color: 'red',
    },
    paid: {
      color: 'green',
    },
  };

  return (
    <div className='container-box'>
      <h5>Pagamentos</h5>
      <span className='title-describe'>Acompanhe seu histórico de pagamentos e faturas pendentes.</span>
      <hr />
      <div className="row text-center">
        <DataTable
          noDataComponent="Sem informações para serem exibidas"
          striped
          pagination
          fixedHeader
          theme="solarized"
          paginationComponentOptions={{
            rowsPerPageText: 'Registros por página',
            rangeSeparatorText: 'de',
            selectAllRowsItem: true,
            selectAllRowsItemText: 'Todos',
          }}
          columns={[
            { name: 'PERIODO', width: '190px', sortable: true, selector: (row) => `${moment(row.periodo_inicio).utc(false).format('DD/MM/YYYY')} - ${moment(row.periodo_fim).utc(false).format('DD/MM/YYYY')}` },
            { name: 'VALOR', sortable: true, selector: (row) => row.valor || 0 },
            { name: 'PLANO', sortable: true, selector: (row) => row.plano_contratado || '' },
            { name: 'PROCESSOS UTILIZADOS', width: '200px', sortable: true, selector: (row) => `${row.processos_utilizados}/${row.processos_contratados}` || '' },
            {
              name: 'SITUAÇÃO',
              sortable: true,
              selector: (row) => row.situacao || '',
              cell: (row) => (
                <div style={row.situacao ? customStyles.paid : customStyles.pending}>
                  {row.situacao ? "Pago" : "Pendente"}
                </div>
              ),
            },
          ]}
          data={data}
        />
      </div>
    </div>
  );
}
